import {getAuthHash} from '@/api/_manager';

const hlsPlayer = {
	data() {
		return {
			hlsObj: null,
		};
	},

	methods: {
		mountPlayer(videoUrl) {
			var self = this;
			var video = document.getElementById('video');

			/**
			 * prepare config
			 */
			var config = {
				maxBufferLength: 20,
				liveBackBufferLength: 18,
				debug: this.$route.query.debug ? true : false,
				xhrSetup: function(xhr, url) {
					const accessToken = JSON.stringify(getAuthHash());
					if (url.indexOf(process.env.VUE_APP_BASE_API_URL) != -1) {
						xhr.setRequestHeader(
							'Authorization',
							`Bearer ${accessToken}`,
						);
					}
				},
			};

			/**
			 * isHLS Supported
			 */
			if (Hls.isSupported()) {
				var hls = new Hls(config);

				this.hlsObj = hls;

				hls.loadSource(videoUrl);
				hls.attachMedia(video);
				hls.on(Hls.Events.MANIFEST_PARSED, function() {
					self._playVideo();
				});

				// Handle Error
				hls.on(Hls.Events.ERROR, function(event, data) {
					// console.log(data);
					switch (data.type) {
						case Hls.ErrorTypes.NETWORK_ERROR:
							self.handleHlsNetworkErrors(data, hls);
							break;
						case Hls.ErrorTypes.MEDIA_ERROR:
							self.handleHlsMediaErrors(data, hls);
							break;
						default:
							self.$store.dispatch('app/showMessage', {
								message: self.$t(
									'screener.watch.cannot_recover',
								),
								color: 'error',
							});
							// cannot recover
							hls.destroy();
							break;
					}
				});
			} else if (video.canPlayType('application/vnd.apple.mpegurl')) {

			/**
			 * HLS is not supported
			 * hls.js is not supported on platforms that do not have Media Source Extensions (MSE) enabled.
			 * When the browser has built-in HLS support (check using `canPlayType`), we can provide an HLS manifest (i.e. .m3u8 URL) directly to the video element through the `src` property.
			 * This is using the built-in support of the plain video element, without using hls.js.
			 * Note: it would be more normal to wait on the 'canplay' event below however on Safari (where you are most likely to find built-in HLS support) the video.src URL must be on the user-driven
			 * white-list before a 'canplay' event will be emitted; the last video event that can be reliably listened-for when the URL is not on the white-list is 'loadedmetadata'.
			 */
				video.src = videoUrl;
				video.addEventListener('loadedmetadata', function() {
					self._playVideo();
				});
			}
		},

		// Handling HLS all network errors
		handleHlsNetworkErrors(data, hls) {
			try {
				// if response is undefined
				if (data.response == undefined) {
					hls.startLoad();
					return;
				}

				// if response code is there
				switch (data.response.code) {
					case this.DEFINES.EVENT_NOT_STARTED:
						this.$store.dispatch('app/showMessage', {
							message: this.$t(
								'screener.watch.screening_started',
							),
							color: 'error',
						});
						break;

					case this.DEFINES.SERVER_ERROR:
						this.$store.dispatch('app/showMessage', {
							message: this.$t('screener.watch.server_error'),
							color: 'error',
						});
						hls.destroy();
						break;

					case this.DEFINES.TOKEN_MISSING:
						this.$store.dispatch('app/showMessage', {
							message: this.$t('screener.watch.token_missing'),
							color: 'error',
						});
						hls.destroy();
						break;

					case this.DEFINES.TOKEN_MISMATCH:
						this.$store.dispatch('app/showMessage', {
							message: this.$t('screener.watch.token_not_match'),
							color: 'error',
						});
						hls.destroy();
						break;

					case this.DEFINES.UNENROLLED:
						this.$store.dispatch('app/showMessage', {
							message: this.$t('screener.watch.not_enrolled'),
							color: 'error',
						});
						hls.destroy();
						break;

					case this.DEFINES.EVENT_FINISHED:
						this.$store.dispatch('app/showMessage', {
							message: this.$t('screener.watch.screening_ended'),
							color: 'error',
						});
						hls.destroy();
						break;

					case this.DEFINES.GEO_BLOCKED:
						this.$store.dispatch('app/showMessage', {
							message: this.$t('screener.geo_blocked'),
							color: 'error',
						});
						hls.destroy();
						break;

					case this.DEFINES.SESSION_DELETED:
						this.$store.dispatch('app/showMessage', {
							message: this.$t('screener.watch.session_deleted'),
							color: 'error',
						});
						hls.destroy();
						break;

					/**
					 * ----- Default do nothing as hls will handle itself -----
					 * */
				}
			} catch (error) {
				hls.startLoad();
			}
		},

		/**
		 *
		 * @param {*} data
		 * @param {*} hls
		 * Handling HLS fatal media errors
		 * non fatal error will be handled by hls itself
		 */

		handleHlsMediaErrors(data, hls) {
			if (data.fatal) {
				// console.log('handling media error');
				hls.startLoad();
			}
		},

		_playVideo() {
			var _this = this;
			document
				.getElementById('video')
				.play()
				.then()
				.catch((err) => {
					/**
					 * show error message
					 */
					_this.$store.dispatch('app/showMessage', {
						message: err,
						color: 'error',
					});
				});
		},

		destroyHLS() {
			if (this.hlsObj) {
				this.hlsObj.destroy();
			}
		},
	},
};

export {hlsPlayer};
